const Nav = {
  init: function () {
    var currentScroll = $(window).scrollTop()
    var lastFocus = null
    var wW =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    var promoActive = !!document.querySelector(".promo-banner") || !!document.querySelector('.announcements-bar__wrapper')
    var hiddenClass = "promo-hidden"
    if (promoActive) {
      $(".header-bar .header-container.header-fixed").addClass("promo-active")
      $("body").addClass("promo-active")
    }

    if ( $('.announcements-bar__wrapper').length ) {
      const slides = $('.announcements-bar')
      const autoplay = $('.announcements-bar__carousel').data('autoplay')
      const autoplayTiming = $('.announcements-bar__carousel').data('timing')
      const isSticky = $('.announcements-bar__carousel').data('sticky')
      const arrows = $('.announcements-bar__carousel').data('arrows')
      const dots = $('.announcements-bar__carousel').data('dots')
      const announcementsCarouselContainer = document.querySelector('.announcements-bar__carousel')
      const announcementsCarousel = new Flickity( announcementsCarouselContainer, {
        cellSelector: ".announcements-bar",
        wrapAround: true,
        prevNextButtons: arrows,
        pageDots: dots && slides.length > 1,
        adaptiveHeight: true,
        autoPlay: autoplay ? autoplayTiming * 1000 : false,
        // autoPlay: false,
        fade: true,
      });

      if ( isSticky ) {
        $('.mainHeader__wrapper').css('top', $('.announcements-bar__carousel').height())
      }
      $('.announcements-bar__carousel_placeholder').addClass('inactive')
      $('.announcements-bar__carousel').removeClass('inactive')

      const dom = {};
      const cacheDom = () => {
        dom.triggers = document.querySelectorAll('.modalToggler');
      }
      const bindUIActions = () => {
        dom.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            let modalTargetId = trigger.dataset.target;
            let modalTarget = document.getElementById(modalTargetId);
            modalTarget.classList.toggle('is--active');
          })
        });
      }
      const init = () => {
        cacheDom();
        bindUIActions();
      }
      init()
    }

    $(window).scroll(function (event) {
      var headerHeight = document.querySelector(".header-bar .header-container.header-fixed")
      if ( headerHeight ) {
        headerHeight = headerHeight.clientHeight
      } else {
        return
      }
      // scrolling down
      if (
        currentScroll < $(window).scrollTop() &&
        currentScroll > headerHeight
      ) {
        $(".header-bar .header-container.header-fixed").addClass(hiddenClass)
        $(".header-bar-blog header").addClass(hiddenClass)
        $(".header-bar .header-container.header-fixed").removeClass("nav-scroll-preview")
        $(".header-bar-blog header").removeClass("nav-scroll-preview")

        setTimeout(function () {
          if ($(window).scrollTop() > headerHeight) {
            $(".header-bar .header-container.header-fixed").addClass("not-transparent")
            $(".header-bar-blog header").addClass("not-transparent")
          }
        }, 500)
        // scrolling up
      } else {
        if (
          currentScroll < headerHeight ||
          $(window).scrollTop() < headerHeight
        ) {
          $(".header-bar .header-container.header-fixed").removeClass("not-transparent")
          $(".header-bar-blog header").removeClass("not-transparent")

          $(".header-bar .header-container.header-fixed").removeClass(hiddenClass)
          $(".header-bar-blog header").removeClass(hiddenClass)

          $(".header-bar .header-container.header-fixed").removeClass("nav-scroll-preview")
          $(".header-bar-blog header").removeClass("nav-scroll-preview")
        } else {
          $(".header-bar .header-container.header-fixed").addClass("nav-scroll-preview")
          $(".header-bar-blog header").addClass("nav-scroll-preview")
        }
      }

      currentScroll = $(window).scrollTop()
    })

    var hasNotTransparent = false
    $("nav li.dropdown").on("mouseenter", function () {
      var $el = $(this)
      $(this).addClass("active")
      if ($(".header-bar .header-container.header-fixed").hasClass("not-transparent")) {
        hasNotTransparent = true
      } else {
        hasNotTransparent = false
      }
      $(".header-bar .header-container.header-fixed").addClass("not-transparent")
      setTimeout(function () {
        $el.find(".dropdown-content").addClass("show")
      }, 1)
    })

    $("nav li.dropdown").on("mouseleave", function () {
      var $el = $(this)
      if (!hasNotTransparent) $(".header-bar .header-container.header-fixed").removeClass("not-transparent")
      $(this).find(".dropdown-content").removeClass("show")
      setTimeout(function () {
        $el.removeClass("active")
      }, 150)
    })

    $("a.hamburger-link").click(function () {
      $(".header-bar .header-container").addClass("mobile-open")
      $(this).hide()
      $(".hamburger-link-close").show()
      $(this).closest(".dropdown").find(".dropdown-content").addClass("active")
      $("body").addClass("fixed")
    })

    $("a.hamburger-link-close").click(function () {
      $(".header-bar .header-container").removeClass("mobile-open")
      $(this).hide()
      $(".hamburger-link").show()
      $(this)
        .closest(".dropdown")
        .find(".dropdown-content")
        .removeClass("active")
      $("body").removeClass("fixed")
    })

    document
      .querySelector(".header_search_toggle")
      .addEventListener("click", () => {
        Nav.showSearch()
      })

    document
      .querySelector(".header_search_toggle--mobile")
      .addEventListener("click", () => {
        Nav.showSearch()
      })

    document.querySelector(".search__close").addEventListener("click", () => {
      Nav.hideSearch()
    })

    document.querySelector(".search__cta").addEventListener("click", () => {
      document.querySelector(".search").submit()
    })

    Nav.initShopMenu()
    Nav.initMobileNav()
  },

  showSearch: function () {
    this.lastFocus = document.activeElement
    document.querySelector(".searchWrapper").style.visibility = "visible"
    document.querySelector(".searchWrapper").classList.add("show")
    document.querySelector(".search__input").focus()
  },

  hideSearch: function () {
    document.querySelector(".searchWrapper").style.visibility = "hidden"
    document.querySelector(".searchWrapper").classList.remove("show")
    this.lastFocus.focus()
  },

  initShopMenu: function () {
    document.querySelectorAll(".nav__shopLeftCta").forEach((el) => {
      el.addEventListener("mouseover", (event) => {
        if (el.classList.contains("selected")) return
        Nav.getShopMenu(el.getAttribute("data-target"))
      })
    })
  },

  getShopMenu: function (id) {
    document.querySelectorAll(".nav__shopLeftCta").forEach((el) => {
      if (el.getAttribute("data-target") == id) {
        el.classList.add("selected")
      } else {
        el.classList.remove("selected")
      }
    })

    document.querySelector(".nav__shopRight.selected").classList.add("hidden")
    document
      .querySelector(".nav__shopRight.selected")
      .classList.remove("selected")
    document
      .querySelector('.nav__shopRight[data-id="' + id + '"]')
      .classList.remove("hidden")
    document
      .querySelector('.nav__shopRight[data-id="' + id + '"]')
      .classList.add("selected")
  },

  initMobileNav: function () {
    document.querySelectorAll(".mobileNav__btn--expander").forEach((el) => {
      el.addEventListener("click", (event) => {
        Nav.toggleMobileExpander(event.currentTarget)
      })
    })
  },

  toggleMobileExpander: function (targetEl) {
    const expander = targetEl.querySelector(".mobileNav__btnExpanderList")
    if (!targetEl.classList.contains("selected")) {
      $(expander)
        .slideDown("slow")
        .animate({ opacity: 1 }, { queue: false, duration: "slow" })
    } else {
      $(expander)
        .slideUp("slow")
        .animate({ opacity: 0 }, { queue: false, duration: "slow" })
    }

    targetEl.classList.toggle("selected")
  },
}

export default Nav
